import React, { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import PageLayout from "../../PageLayout";
import TaskHeader from "../DesignJobs/TaskHeader";
import { useDispatch, useSelector } from "react-redux";
import { getTaskDetails } from "../../../store/actions/taskDetailAction";
import "../DesignJobs/index.scss";
import { useParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import CloneJobs from "../DesignJobs/CloneJobs";
import "./index.scss";
import CDHeader from "../DesignJobs/CDHeader";
import { saveColorDevelopment, submitColorDevelopment } from "../../../apis/colorDevelopmentApi";
import { CheckReadOnlyAccess, createDesignJobName } from "../../../utils";
import IQCDFooterButtons from "../DesignJobs/IQCDFooterButtons";
import _, { cloneDeep } from "lodash";
import { SpecialProjectAction } from "../../../store/actions/ProjectSetupActions";
import { redirectUnallocatedLinksToArtworkStatus } from "../../../utils";
import { UnsavedChangesDialog, useUnsavedChangesWarning } from "../../common/NavigationPrompt";
import UnAuthorizedComponent from "../../UnAuthorized/UnAuthorizedComponent";
import { getReadWriteAccessForTask, getUserAccessForTask } from "../../../Utils/helpers";

const breadcrumb = [{ label: "Define Color Development & Print Trial" }];

const headerName = "Define Color Development  & Print Trial";
const jobName = "CD_";

function DNPF() {
  const dispatch = useDispatch();
  const { TaskDetailsData, loading } = useSelector((state) => state.TaskDetailsReducer);
  const [data, setData] = useState(null);
  const [CD, setCD] = useState([]);
  const [initialCD, setInitialCD] = useState([]);
  const [cancelClicked, setCancelClicked] = useState(false)
  const [formValid, setFormValid] = useState(false);
  const [formValidForSaveAsDraft, setFormValidForSaveAsDraft] = useState(false);
  const [updated, setUpdated] = useState(false);
  const [submittedDI, setSubmittedDI] = useState([]);
  const [loader, setLoader] = useState(true);
  const [selectAllCheckbox, setSelectAllCheckbox] = useState(false);
  const [dropDownMatch, setDropDownMatch] = useState(true);
  const [inputValid,setInputValid]=useState({});

  let { page1, page2, pageType, TaskID, ProjectID } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const currentUrl = location?.pathname;
  // const checkReadWriteAccess = CheckReadOnlyAccess();
  const {
    userDetails: { UserGroup },
  } = useSelector((state) => state?.UserDetailsReducer);
  const User = useSelector((state) => state.UserReducer);
  const userInformation = User?.userInformation;
  const userAccessPayLoad = {
    ArtworkAgilityPage: {
      UserId: userInformation?.userid,
      ProjectID: ProjectID,
      UserGroup: UserGroup
    }
  }
  const [accessSecurityMatrix, setUserAccess] = useState(false);
  const [checkReadWriteAccess, setCheckReadWriteAccess] = useState(false);

  const [FormObjects, setFormObjects] = useState({
    Printer:[],
    Pantone:"",
    Select:false,
    Substrate:"",
    FileDetails:[],
    CD_Approved:false,
    Additional_Info:"",
    Printing_Process:"",
    Print_Trial_Done:false,
    IDDSampleApproved:false,
    Print_Trial_Needed:false,
    IDDSampleLabTestApproved:false,
  });
  const [pageEdited, setPageEdited] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const { markDirty, markClean } = useUnsavedChangesWarning();
  const [InitialFormObjects, setInitialFormObjects] = useState({
    Printer:[],
    Pantone:"",
    Select:false,
    Substrate:"",
    FileDetails:[],
    CD_Approved:false,
    Additional_Info:"",
    Printing_Process:"",
    Print_Trial_Done:false,
    IDDSampleApproved:false,
    Print_Trial_Needed:false,
    IDDSampleLabTestApproved:false,
  });

  useEffect(()=>{
    const updatedCD = _.cloneDeep(CD).filter((obj)=>{
      return obj.Action !== "delete" 
      // && (obj?.Design_Job_ID?.toString()?.includes("NPF_") || obj?.Select || obj?.Printer?.length || obj?.Printing_Process || obj?.Substrate || obj?.Additional_Info || obj?.Print_Trial_Needed)
  })
    const isObjectEqual = JSON.stringify(initialCD) === JSON.stringify(updatedCD)
    if(!isObjectEqual){
      setPageEdited(true);
    }else{
      setPageEdited(false);
    }
  },[CD])

  useEffect(() => {
    if (pageEdited) {
      markDirty();
    } else {
      markClean();
    }
  }, [pageEdited]);

  useEffect(()=>{
    markClean();
    setPageEdited (false);
  },[]);

  let Brand = [];
  let Category = [];

  useEffect(()=>{
    setUserAccess(getUserAccessForTask(TaskDetailsData));
    setCheckReadWriteAccess(getReadWriteAccessForTask(TaskDetailsData));
  },[TaskDetailsData?.AccessType])

  if (TaskDetailsData?.ArtworkAgilityPage) {
    Brand = TaskDetailsData.ArtworkAgilityPage.Artwork_Brand;
    Category = TaskDetailsData.ArtworkAgilityPage.Artwork_Category;
  }

  useEffect(() => {
    if(userInformation?.userid && UserGroup?.length){
    let taskId;
    if (TaskID) {
      taskId = TaskID.split("_")[1];
    }
    setLoader(false)
    dispatch(getTaskDetails(TaskID, ProjectID, userAccessPayLoad));
    }
  }, [dispatch, TaskID, ProjectID, userInformation?.userid, UserGroup?.length]);

  useEffect(() => {
    if (TaskDetailsData) {
      setInitialCD(TaskDetailsData?.ArtworkAgilityTasks?.[0]?.DesignJobDetails || [])
      setCD(TaskDetailsData?.ArtworkAgilityTasks?.[0]?.DesignJobDetails || []);
      setData(TaskDetailsData?.ArtworkAgilityTasks?.[0] || []);

      const specialProjectFlag = TaskDetailsData?.SpecialProject;
      dispatch(SpecialProjectAction(specialProjectFlag));
      redirectUnallocatedLinksToArtworkStatus(currentUrl, specialProjectFlag, navigate);
    }
  }, [TaskDetailsData]);

  const handleCancel = () => {
    if (page2 && page2 === "projectPlan") {
      navigate(`/${page1}/${page2}/${TaskDetailsData?.ArtworkAgilityPage?.AWM_Project_ID}`);
    } else if (pageType) {
      navigate(`/${pageType}`);
    }
  };

  const handleCancelClick = () =>{
    setCancelClicked(true)
    if(pageEdited){
      setShowDialog(true);
    }else{
      handleCancel();
    }
  }

  // it will hide warning dialog
  const cancelNavigation = () => {
    setShowDialog(false);
  }
  // it will navigate to previously saved url navigate(pendingNavigation);
  // by doing setShowDialog(false) and setPendingNavigation("");
  const confirmNavigation = () => {
    markClean();
    handleCancel();
    setPageEdited(false);
    setShowDialog(false);
  }

  const handleDelete = (index) => {
    const sub = CD?.map((item, i) => {
      if (i === index) {
        item.Action = "delete";
      }
      return item;
    });

    const notDeletedItems = CD.filter((item) => {
      return item.Action !== "delete";
    });
    if (notDeletedItems.length === 0) {
      setSelectAllCheckbox(false);
    }
    setCD(sub);
  };

  useEffect(() => {
    checkFormValidityWithoutCheckbox(CD);
    checkFormValidityForSaveAsDraft(CD);
  }, [CD, data, dropDownMatch]);

  const addNewEmptyDesign = () => {
    const newDesignIntent = [
      ...CD,
      {
        Design_Job_ID: CD.length + 1,
        isNew: true,
        Design_Job_Name: "",
        Print_Trial_Done: null,
        Tier: "",
        Cluster: "",
        Agency_Reference: "",
        // Printer: [],
        Printing_Process: "",
        Design_Job_Name: "",
        Substrate: "",
        Additional_Info: "",
        CD_Approved: null,
        Select: null,
        Print_Trial_Needed: null,
        Design_Job_Status: "",
      },
    ];
    setCD(newDesignIntent);
    setUpdated(!updated);
  };

  const addData = (fieldName, index, value, Design_Intent_Name) => {
    let Project_Name = TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Project_Name;
    let initialCDdata = cloneDeep(initialCD);
    let initialData = initialCDdata[index];
    let CDdata = cloneDeep(CD);
    let data = CDdata[index];
    data[fieldName] = value;
    if(fieldName === "Printer" && !value?.length){
       delete data[fieldName]
    }
    let designJobName = (data?.Printer?.length || data?.Printing_Process || data?.Substrate ||data?.Additional_Info || data?.Print_Trial_Needed) ? 
    createDesignJobName(
      data.Printer,
      data.Pantone,
      data.Printing_Process,
      data.Substrate,
      data.Additional_Info,
      Project_Name,
      Brand,
      Category,
      data?.Print_Trial_Needed ? "PT_" : jobName
    ) : 
    initialData?.Design_Job_Name || "";
    data["Design_Job_Name"] = designJobName;
    if (fieldName === "Select") {
      let checkedLineItems = CDdata.filter((obj) => {
        return obj.Select === true;
      });
      if (checkedLineItems.length === CDdata.length) {
        setSelectAllCheckbox(true);
      } else {
        setSelectAllCheckbox(false);
      }
    }
    setCD(CDdata);

    setSubmittedDI(Math.random());
    checkFormValidityWithoutCheckbox(CDdata);
    checkFormValidityForSaveAsDraft(CDdata);
    // if(value){
      setFormObjects((prev)=>{
        return{
          ...prev,
          [fieldName]:value,
        }
      })
    // }
  };

  useEffect(() => {
    let count = 0;
    CD?.forEach((obj) => {
      if (obj.Select) {
        count++;
      }
    });
    if (CD.length!== 0 && CD.length === count) {
      setSelectAllCheckbox(true);
    } else {
      setSelectAllCheckbox(false);
    }
  }, [submittedDI]);

  const checkFormValidity = (CDdata) => {
    const validTasks = CDdata?.filter((task) => {
      return (
        task?.Printing_Process &&
        task?.Substrate &&
        task?.Select &&
        (task.Design_Job_Status === "Awaiting" || task.Design_Job_Status === "") &&
        (task?.Action !=="delete") &&
        task?.Printer?.length >= 1
      );
    });
    const selectedTasks = CDdata?.filter((task) => {
      return (
        task?.Select && 
        (task.Design_Job_Status === "Awaiting" || task.Design_Job_Status === "") &&
        (task?.Action !=="delete")
      );
    });
    if (
      validTasks?.length > 0 &&
      selectedTasks?.length > 0 &&
      validTasks?.length === selectedTasks?.length &&
      dropDownMatch
    ) {
      setFormValid(true);
    } else {
      setFormValid(false);
    }
  };

const checkFormValidityWithoutCheckbox = (CDdata) => {
    const validTasks = CDdata?.filter((task) => {
      return (
        task?.Printing_Process &&
        task?.Substrate &&
        (task.Design_Job_Status === "Awaiting" || task.Design_Job_Status === "") &&
        (task?.Action !=="delete") &&
        task?.Printer?.length >= 1
      );
    });
    if (
      validTasks?.length > 0 &&
      dropDownMatch
    ) {
      setFormValid(true);
    } else {
      setFormValid(false);
    }
  };

  const checkFormValidityForSaveAsDraft = (CDdata) => {
    const lineItems = CDdata?.filter((task) => {
      return task?.Design_Job_Status === "Awaiting";
    });

    if (lineItems?.length > 0) {
      setFormValidForSaveAsDraft(true);
    } else {
      setFormValidForSaveAsDraft(false);
    }
  };

  const onSelectAll = (checked) => {
    let CDdata = cloneDeep(CD);
    CDdata?.forEach((task) => {
      if (task?.Design_Job_Status === "Awaiting" || task?.Design_Job_Status === "") {
        task.Select = checked;
      }
    });
    setCD(CDdata);
    setUpdated(!updated);
  };

  const handleDeleteJob = async (Design_Job_ID) => {
    setLoader(true);
    let pageInstructions = [];

    let submitOnlySelectedData = CD?.filter((task) => Design_Job_ID === task?.Design_Job_ID);
    if (submitOnlySelectedData?.length > 0) {
      let temp = {};
      temp["instruction"] = "APPEND";
      temp["target"] = "NewPrintFeasibilityList";
      temp["content"] = {
        DesignJobName: submitOnlySelectedData[0]?.Design_Job_Name,
        DesignJobID: submitOnlySelectedData[0]?.Design_Job_ID,
        PrintingProcess: submitOnlySelectedData[0]?.Printing_Process,
        Substrate: submitOnlySelectedData[0]?.Substrate,
        Select: submitOnlySelectedData[0]?.Select?.toString(),
        PrintTrialNeeded: submitOnlySelectedData[0]?.Print_Trial_Needed?.toString(),
        AdditionalInfo: submitOnlySelectedData[0]?.Additional_Info,
        Action: "delete",
        // Printer: submitOnlySelectedData[0]?.Printer ? submitOnlySelectedData[0].Printer : [],
      };
      pageInstructions.push(temp);
    }

    let formData = {
      caseTypeID: "PG-AAS-Work-DefineNewPrintFeasibilityScope",
      content: {
        AWMTaskID: data.Task_ID,
        AWMProjectID: TaskDetailsData?.ArtworkAgilityPage?.AWM_Project_ID,
      },
      pageInstructions: pageInstructions,
    };

    let id = data.Task_Key;
    const headers = {
      key: "If-Match",
      value: TaskDetailsData?.ArtworkAgilityPage?.Etag,
    };

    await submitColorDevelopment(formData, id, headers);
    dispatch(getTaskDetails(TaskID, ProjectID, userAccessPayLoad));
    setLoader(false);
  };

  const onSubmit = async () => {
    setLoader(true);
    let pageInstructions = [];

    /** START CODE - AGL-608 - default make all  checkbox selected */

    CD.map((task) => {
      if ( task?.Printer?.length > 0 && task?.Printing_Process && task?.Substrate ) {
        task.Select = true;
      } 
      return task;
    });

  /** END CODE - AGL-608 - default make all  checkbox selected */

    let submitOnlySelectedData = CD?.filter(
      (task) =>
        task?.Select === true &&
        (task?.Design_Job_Status === "" ||
          task?.Design_Job_Status === "Awaiting" ||
          task?.isNew === true)
    );
    submitOnlySelectedData.forEach((task) => {
      let taskAction = "update";
      if (task?.Action !== "delete" && task?.Design_Job_ID) {
        taskAction = "update";
      }
      if (task?.Action !== "delete" && task?.isNew === true) {
        taskAction = "add";
      }
      if (task?.Action === "delete") {
        taskAction = "delete";
      }
      let taskDesignJobID = task?.Design_Job_ID;
      if (task?.isNew) {
        taskDesignJobID = "";
      }
      let temp = {};
      temp["instruction"] = "APPEND";
      temp["target"] = "NewPrintFeasibilityList";
      temp["content"] = {
        DesignJobName: task?.Design_Job_Name,
        DesignJobID: taskDesignJobID,
        PrintingProcess: task?.Printing_Process,
        Substrate: task?.Substrate,
        Select: task?.Select?.toString(),
        PrintTrialNeeded: task?.Print_Trial_Needed?.toString(),
        AdditionalInfo: task?.Additional_Info,
        Action: taskAction,
        Printer: task?.Printer,
      };
      pageInstructions.push(temp);
    });
    let formData = {
      caseTypeID: "PG-AAS-Work-DefineNewPrintFeasibilityScope",
      content: {
        AWMTaskID: data.Task_ID,
        AWMProjectID: TaskDetailsData?.ArtworkAgilityPage?.AWM_Project_ID,
      },
      pageInstructions: pageInstructions,
    };

    let id = data.Task_Key;
    const headers = {
      key: "If-Match",
      value: TaskDetailsData?.ArtworkAgilityPage?.Etag,
    };

    await submitColorDevelopment(formData, id, headers);
    setLoader(false);

    if (page2 && page2 === "projectPlan") {
      navigate(`/${page1}/${page2}/${TaskDetailsData?.ArtworkAgilityPage?.AWM_Project_ID}`);
    } else if (pageType) {
      navigate(`/${pageType}`);
    }
  };

  const onSaveAsDraft = async () => {
    setLoader(true);
    let counter = 0;
    let submitOnlySelectedData = CD?.filter(
      (task) => task?.Design_Job_Status === "Awaiting" || task?.Design_Job_Status === ""
    );

    submitOnlySelectedData.map((task) => {
      counter++;

      if (task?.Action !== "delete" && task?.Design_Job_ID) {
        task.Action = "update";
      }
      if (task?.Action !== "delete" && task?.isNew === true) {
        task.Action = "add";
      }
      if (task?.Action === "delete") {
        task.Action = "delete";
      }
      if (task?.isNew) {
        task.Design_Job_ID = "";
      }

      task.Design_Job_Name = task?.Design_Job_Name;

      return task;
    });

    let formData = {
      AWM_Project_ID: TaskDetailsData?.ArtworkAgilityPage?.AWM_Project_ID,
      AWM_Task_ID: data.Task_ID,
      Project_Name: TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Project_Name,
      BU: TaskDetailsData?.ArtworkAgilityTasks?.[0]?.BU,
      Region: TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Region,
      NewPrintFeasibilityList: submitOnlySelectedData,
    };

    await saveColorDevelopment(formData);
    dispatch(getTaskDetails(TaskID, ProjectID, userAccessPayLoad));
    setLoader(false);
  };

  const loadOnClearButton = () => {
    dispatch(getTaskDetails(TaskID, ProjectID, userAccessPayLoad));
  };

  return (
    <PageLayout>
      {loader || loading || CD === null ? (
        <LoadingOverlay active={loader || loading || CD === null} spinner text="" className="overlay-loader" />
      ) : accessSecurityMatrix ?
        <>
        <CDHeader
          setAddNewDesign={addNewEmptyDesign}
          onSelectAll={onSelectAll}
          selectAllCheckbox={selectAllCheckbox}
          breadcrumb={breadcrumb}
          headerName={headerName}
          label="Define Color Development & Print Trial"
          checkReadWriteAccess={checkReadWriteAccess}
          data={data}
          lastLabel={"DNPF"}
          pageEdited={pageEdited}
          setPageEdited={setPageEdited}
        />
        <div className="task-details">
          {<TaskHeader {...data} TaskDetailsData={TaskDetailsData} pageEdited={pageEdited} setPageEdited={setPageEdited} />}
          {CD &&
            CD.length > 0 &&
            CD.map((item, index) => {
              if (item && item?.Action !== "delete") {
                return (
                  <CloneJobs
                    key={index}
                    {...data}
                    data={data}
                    item={item}
                    AWMProjectID={TaskDetailsData?.ArtworkAgilityPage?.AWM_Project_ID}
                    AWMTaskID={TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Task_ID}
                    Bu={TaskDetailsData?.ArtworkAgilityTasks?.[0]?.BU}
                    Region={TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Region}
                    hideClearButton={true}
                    handleDeleteJob={handleDeleteJob}
                    loadOnClearButton={loadOnClearButton}
                    onSaveAsDraft={onSaveAsDraft}
                    index={index}
                    pageEdited={pageEdited}
                    setPageEdited={setPageEdited}
                    addData={addData}
                    handleDelete={handleDelete}
                    jobName={item?.Print_Trial_Needed ? "PT_" : jobName}
                    setFormValid={setFormValid}
                    checkReadWriteAccess={checkReadWriteAccess}
                    Artwork_Brand={TaskDetailsData?.ArtworkAgilityPage?.Artwork_Brand}
                    Artwork_Category={TaskDetailsData?.ArtworkAgilityPage?.Artwork_Category}
                    Taskdata={TaskDetailsData}
                    setDropDownMatch={setDropDownMatch}
                    showDialog={showDialog}
                    setShowDialog={setShowDialog}
                    cancelClicked={cancelClicked}
                    setCancelClicked={setCancelClicked}
                    handleCancel={handleCancel}
                    setInputValid={setInputValid}

                  />
                );
              }
            })}
        </div>
        <IQCDFooterButtons
          handleCancel={handleCancelClick}
          onSaveAsDraft={onSaveAsDraft}
          onSubmit={onSubmit}
          formValid={!formValid}
          pageEdited={pageEdited}
          setPageEdited={setPageEdited}
          checkReadWriteAccess={checkReadWriteAccess}
          bottomFixed={true}
          data={data}
          formValidForSaveAsDraft={formValidForSaveAsDraft}
        />
        
      {/* UnsavedChangesDialog popup*/}   
      {/* <UnsavedChangesDialog
        visible={showDialog}
        onCancel={cancelNavigation}
        onConfirm={confirmNavigation}
      /> */}
        </>
      : <UnAuthorizedComponent nowrapper={true} />
      }
    </PageLayout>
  );
}

export default DNPF;
